import React from 'react';
import { Box, Typography, Paper, FormControlLabel, Switch, useTheme } from '@mui/material';
// 1. Importe o nosso hook customizado em vez do useContext
import { useThemeToggle } from '../contexts/ThemeContext'; 

const SettingsPage = () => {
    const theme = useTheme(); 
    // 2. Use o hook para pegar a função de toggle
    const { toggleColorMode } = useThemeToggle(); 

    return (
        <Paper elevation={3} sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Configurações
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Personalize as configurações da sua conta e da aplicação.
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                <Box>
                    <Typography variant="h6">Tema da Aplicação</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Modo atual: {theme.palette.mode === 'light' ? 'Claro' : 'Escuro'}
                    </Typography>
                </Box>
                <FormControlLabel
                    control={
                        <Switch
                            checked={theme.palette.mode === 'dark'}
                            // 3. Chame a função com o nome correto: toggleColorMode
                            onChange={toggleColorMode} 
                        />
                    }
                    label={theme.palette.mode === 'dark' ? 'Ativado' : 'Desativado'}
                    labelPlacement="start"
                />
            </Box>
        </Paper>
    );
};

export default SettingsPage;